import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx } from "react/jsx-runtime";
import { getSpacing } from "@faire/web--source/slate/spacing/getSpacing";
import { assignInlineVars } from "@vanilla-extract/dynamic";
import cn from "classnames";
import React from "react";
import { isResponsiveProp } from "../Theme/ResponsiveProp";
// eslint-disable-next-line import/no-unassigned-import
import "./native-styles.css";
/**
 * @trackcomponent
 *
 * @link [Docs](https://slate.faire.team/component/spacer/web/spacer)
 */ export var Spacer = function(_param) {
    var ref = _param.ref, heightProp = _param.height, widthProp = _param.width, sizeProp = _param.size, className = _param.className, styleProp = _param.style, children = _param.children, rest = _object_without_properties(_param, [
        "ref",
        "height",
        "width",
        "size",
        "className",
        "style",
        "children"
    ]);
    var styles = {};
    var vars = {};
    var classNames = [];
    var _ref;
    var definedSize = (_ref = sizeProp !== null && sizeProp !== void 0 ? sizeProp : widthProp) !== null && _ref !== void 0 ? _ref : heightProp;
    if (definedSize != null) {
        if (isResponsiveProp(definedSize)) {
            vars["--f_spacer_size_mobile"] = getSpacing(definedSize.mobileAndAbove);
            vars["--f_spacer_size_tablet"] = definedSize.tabletAndAbove != null ? getSpacing(definedSize.tabletAndAbove) : vars["--f_spacer_size_mobile"];
            vars["--f_spacer_size_desktop"] = definedSize.desktopAndAbove != null ? getSpacing(definedSize.desktopAndAbove) : vars["--f_spacer_size_tablet"];
            vars["--f_spacer_size_xlarge"] = definedSize.xLargeAndAbove != null ? getSpacing(definedSize.xLargeAndAbove) : vars["--f_spacer_size_desktop"];
            vars["--f_spacer_size_xxlarge"] = definedSize.xxLargeDesktop != null ? getSpacing(definedSize.xxLargeDesktop) : vars["--f_spacer_size_xlarge"];
            classNames.push("f_spacer_variable_fb");
            if ((sizeProp !== null && sizeProp !== void 0 ? sizeProp : widthProp) != null) {
                classNames.push("f_spacer_variable_min_width");
            }
            if ((sizeProp !== null && sizeProp !== void 0 ? sizeProp : heightProp) != null) {
                classNames.push("f_spacer_variable_min_height");
            }
        } else {
            vars["--f_spacer_size_mobile"] = getSpacing(definedSize);
            classNames.push("f_spacer_single_value_fb");
            if ((sizeProp !== null && sizeProp !== void 0 ? sizeProp : widthProp) != null) {
                classNames.push("f_spacer_single_value_min_width");
            }
            if ((sizeProp !== null && sizeProp !== void 0 ? sizeProp : heightProp) != null) {
                classNames.push("f_spacer_single_value_min_height");
            }
        }
        styles = _object_spread({}, widthProp ? {
            height: 0
        } : {}, heightProp ? {
            width: 0
        } : {});
    }
    return /*#__PURE__*/ _jsx("div", _object_spread_props(_object_spread({
        ref: ref,
        style: _object_spread({}, assignInlineVars(vars), styles, styleProp),
        className: cn(className, "f_spacer_base", classNames)
    }, rest), {
        children: children
    }));
};
/**
 * @trackcomponent
 *
 * @link [Docs](https://slate.faire.team/component/spacer/web/growing-spacer)
 */ export var GrowingSpacer = function(_param) {
    var ref = _param.ref, sizeProp = _param.base, className = _param.className, styleProp = _param.style, children = _param.children, rest = _object_without_properties(_param, [
        "ref",
        "base",
        "className",
        "style",
        "children"
    ]);
    var vars = {};
    var classNames = [];
    if (sizeProp != null) {
        if (isResponsiveProp(sizeProp)) {
            vars["--f_spacer_size_mobile"] = getSpacing(sizeProp.mobileAndAbove);
            vars["--f_spacer_size_tablet"] = sizeProp.tabletAndAbove != null ? getSpacing(sizeProp.tabletAndAbove) : vars["--f_spacer_size_mobile"];
            vars["--f_spacer_size_desktop"] = sizeProp.desktopAndAbove != null ? getSpacing(sizeProp.desktopAndAbove) : vars["--f_spacer_size_tablet"];
            vars["--f_spacer_size_xlarge"] = sizeProp.xLargeAndAbove != null ? getSpacing(sizeProp.xLargeAndAbove) : vars["--f_spacer_size_desktop"];
            vars["--f_spacer_size_xxlarge"] = sizeProp.xxLargeDesktop != null ? getSpacing(sizeProp.xxLargeDesktop) : vars["--f_spacer_size_xlarge"];
            classNames.push(".f_spacer_variable_fb");
        } else {
            vars["--f_spacer_size_mobile"] = getSpacing(sizeProp);
            classNames.push("f_spacer_single_value_fb");
        }
    }
    return /*#__PURE__*/ _jsx("div", _object_spread_props(_object_spread({
        ref: ref,
        style: _object_spread({}, assignInlineVars(vars), styleProp),
        className: cn(className, "f_spacer_grow", classNames)
    }, rest), {
        children: children
    }));
};
